var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.03 19.549 7 13.517v7.248h5.558c.065-.435.226-.85.473-1.218zm-.472 2.405H7a8.724 8.724 0 0 0 2.106 5.115l3.925-3.968a2.554 2.554 0 0 1-.472-1.147zm8.766-7.148A8.38 8.38 0 0 0 16.21 12.7v5.552c.426.07.83.227 1.19.467l3.924-3.913zm-3.008 8.237 3.925 3.924a8.595 8.595 0 0 0 2.063-5.043h-5.586a3.375 3.375 0 0 1-.4 1.12zm.402-2.277h5.558a8.725 8.725 0 0 0-2.106-5.115l-3.926 3.939c.247.35.41.754.474 1.177zm-8.774 7.127A8.38 8.38 0 0 0 15.06 30v-5.565a2.997 2.997 0 0 1-1.19-.467l-3.926 3.926zm6.266-3.46v5.558a8.583 8.583 0 0 0 5.115-2.136l-3.897-3.898c-.37.239-.783.4-1.218.476zM7 11.72c1.49 1.49 6.16 6.203 6.948 6.977a3.545 3.545 0 0 1 1.089-.445V9.177L7.014 2C7 2 7 11.456 7 11.72z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBts);
export default __webpack_public_path__ + "static/media/BTS.7abe22c8f67c733c29230e8be5715cb6.svg";
export { ForwardRef as ReactComponent };